import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  keybindElements = document.querySelectorAll(".game-key-bind-list__input");
  keybinding      = false;

  initialize() {
    for (const keybindElement of this.keybindElements) {
      const inputElement = keybindElement.querySelector("input");
      const labelElement = keybindElement.querySelector("label");

      inputElement.addEventListener("focus", this.onInputFocused.bind(this, labelElement));
      inputElement.addEventListener("blur", this.onInputUnfocused.bind(this, labelElement));
    }

    $(document).on("opening", "[data-remodal-id=modalKeyBind]", this.onKeybindingStart.bind(this));
    $(document).on("closing", "[data-remodal-id=modalKeyBind]", this.onKeybindingEnd.bind(this));
  }

  /**s
   * Event Hooks
   */

  onInputFocused(labelElement) {
    labelElement.style.color = "#4a83ff";
  }

  onInputUnfocused(labelElement) {
    labelElement.style.color = "";
  }

  onKeybindingStart() {
    this.keybinding = true;

    this.keybindingLoop();
  }

  onKeybindingEnd() {
    this.keybinding = false;
  }

  /**
   * Utilitites
   */

  keybindingLoop() {
    for (const keybindElement of this.keybindElements) {
      const inputElement = keybindElement.querySelector("input");
      const labelElement = keybindElement.querySelector("label");
      const actualInputValue  = inputElement.value;
      const actualLabelValue  = labelElement.innerHTML;

      if (actualInputValue != actualLabelValue) {
        labelElement.innerHTML = actualInputValue;
      }
    }

    if (this.keybinding) requestAnimationFrame(this.keybindingLoop.bind(this));
  }
}
